import React, { useState, useEffect, useRef } from 'react';

/**
 * StreamingSQL - Displays SQL with a typewriter effect on first render
 */
const StreamingSQL = ({ sql, formatFn, messageId, hasStreamed, onStreamComplete, startDelay = 0 }) => {
  const [displayedChars, setDisplayedChars] = useState(hasStreamed ? sql.length : 0);
  const [isComplete, setIsComplete] = useState(hasStreamed);
  const [canStartStreaming, setCanStartStreaming] = useState(hasStreamed || startDelay === 0);
  
  // Wait for delay before starting to stream
  useEffect(() => {
    if (hasStreamed || canStartStreaming) return;
    
    const timer = setTimeout(() => {
      setCanStartStreaming(true);
    }, startDelay);
    
    return () => clearTimeout(timer);
  }, [hasStreamed, startDelay, canStartStreaming]);
  
  // Streaming effect
  useEffect(() => {
    if (!canStartStreaming || hasStreamed) return;
    
    if (displayedChars < sql.length) {
      const timer = setTimeout(() => {
        setDisplayedChars(prev => Math.min(prev + 3, sql.length));
      }, 15);
      return () => clearTimeout(timer);
    } else if (!isComplete) {
      setIsComplete(true);
      if (onStreamComplete) {
        onStreamComplete(messageId);
      }
    }
  }, [displayedChars, sql.length, hasStreamed, isComplete, messageId, onStreamComplete, canStartStreaming]);
  
  const visibleSQL = hasStreamed ? sql : sql.substring(0, displayedChars);
  const showCursor = !isComplete && canStartStreaming;
  
  return (
    <pre 
      className="text-xs font-mono overflow-x-auto whitespace-pre leading-relaxed text-gray-200"
      dangerouslySetInnerHTML={{ 
        __html: (visibleSQL ? formatFn(visibleSQL) : '&nbsp;') + (showCursor ? '<span class="animate-pulse text-white">▌</span>' : '') 
      }}
    />
  );
};

export default StreamingSQL;
